import { useTranslation } from 'react-i18next';

/**
 * A reservation status, as a chip.
 *
 * Cancelled and no-show statuses are visually quieter rather than louder: they
 * are the rows a host scrolls past, and making them shout would drown the
 * bookings that still need attention.
 */
const TONE: Record<string, string> = {
  pending: 'bg-slate-100 text-slate-700',
  confirmed: 'bg-brand-teal-light text-brand-teal-dark',
  reconfirmed: 'bg-brand-teal-light text-brand-teal-dark',
  arrived: 'bg-sky-100 text-sky-800',
  seated: 'bg-blue-100 text-blue-800',
  dessert: 'bg-purple-100 text-purple-800',
  check_dropped: 'bg-orange-100 text-orange-800',
  finished: 'bg-slate-100 text-slate-500',
  no_show: 'bg-red-50 text-red-700',
  cancelled_by_guest: 'bg-slate-50 text-slate-400',
  cancelled_by_venue: 'bg-slate-50 text-slate-400',
  late_cancel: 'bg-red-50 text-red-600',
};

export function StatusPill({ status }: { status: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${
        TONE[status] ?? TONE.pending
      }`}
    >
      {t(`status.${status}`)}
    </span>
  );
}
